import { useState } from "react";
import CommentReaction from "./CommentReaction";
import { CommentReactions } from "@/api/AppApi/services/blogs/interfaces/IBlogs";

interface props {
  blogSlug:string
  commentId:number
  name: string;
  date: string;
  discription: string;
  likes: number;
  disLikes: number;
  reaction: CommentReactions | null;
  isReply: boolean;
  selectedCommentToReply: number | null;
  setSelectedCommentToReply: (selectedComment: number | null) => void;
}
const CommentMainPart: React.FC<props> = ({
  blogSlug,
  commentId,
  name,
  date,
  discription,
  likes,
  disLikes,
  reaction,
  isReply,
  selectedCommentToReply,
  setSelectedCommentToReply,
}) => {
  const discriptionLenght = discription?.length;
  const maxchar = 264;
  const isLogText = discriptionLenght > maxchar;
  const [isSeeMore, setIsSeeMore] = useState(isLogText);
  const [textToRender, setTextToRender] = useState(
    discription?.length < maxchar
      ? discription
      : discription?.slice(0, 264) + "..."
  );
  const handleClickSeeMore = () => {
    setIsSeeMore(false);
    setTextToRender(discription);
  };

  return (
    <div className="main-content">
      <h3 className="m-0 name">{name}</h3>
      <p className=" m-0 date">{date}</p>
      <p className="m-0 comment-text">
        {textToRender}{" "}
        {isSeeMore && (
          <span className="see-more" onClick={handleClickSeeMore}>
            see more
          </span>
        )}
      </p>
      <CommentReaction
      commentId={commentId}
        selectedCommentToReply={selectedCommentToReply}
        setSelectedCommentToReply={setSelectedCommentToReply}
        likes={likes}
        disLikes={disLikes}
        reaction={reaction}
        isReply={isReply}
        blogSlug={blogSlug}
      />
    </div>
  );
};

export default CommentMainPart;
